import React from 'react';
import Products from '../components/Products';
import Banner from '../components/Banner';

const Home = () => {
  return (
    <>
      <Banner />
      <Products />
    </>
  );
};

export default Home;
